import { useQuery } from 'react-query';
import { QueryConfig } from '../lib/react-query';
import { PromiseValue } from 'type-fest';

import axios from "axios";

type GetVVPLayoutsResponse = {
  layouts: VVPLayout[];
  success: string;
};

type VVPLayout = {
  vvp_layout_id: number;
  type: string;
  name: string;
  display_name: string;
  version: number;
  metadata: string;
  csv: string;
  description: string;
  is_public: number;
  preview_image: string;
  summary: string;
  timestamp: string;
  author_id: number;
};

type VVPLayoutTypes = string[];
type VVPLayouts = VVPLayout[];

type VVPLayoutsData = {
  types: VVPLayoutTypes;
  layouts: VVPLayouts;
};

export const getVVPLayouts = (): Promise<VVPLayoutsData> => {
  return axios.post('/vue_api/get_vvp_layouts').then((resp: any) => {
    console.log("getVVPLayouts", resp);
    const data: VVPLayoutsData = {
      types: resp.data.layouts
        .map((item: VVPLayout) => item.type)
        .filter((value: any, index: number, self: any) => self.indexOf(value) === index),
      layouts: resp.data.layouts,
    };
    return data;
  });
};

type UseVVPLayoutsOptions = {
  config?: QueryConfig<typeof getVVPLayouts>;
};

export const useVVPLayouts = ({ config }: UseVVPLayoutsOptions) => {
  return useQuery({
    ...config,
    cacheTime: 0,
    queryKey: ['vvpLayouts'],
    queryFn: () => getVVPLayouts(),
  });
};
